import {
  HistoryDepositDto,
  HistoryDepositReferralRewardDto,
  HistoryDepositRewardDailyDto,
  HistoryDepositRewardDto,
  HistoryDepositRewardVestingDto,
  HistoryDetailsDto,
  HistoryWithdrawalDto,
  HistoryWTTBonusDto,
  HistoryDepositRewardRefBonusDto,
  HistoryWithdrawalDepositRewardRefBonusDto,
  HistoryWithdrawalReinvest,
} from "@/modules/user/types/history";

export const isDeposit = (
  details: HistoryDetailsDto
): details is HistoryDepositDto => {
  return "tokenAmount" in details && "fromAddress" in details;
};

export const isDepositRefReward = (
  details: HistoryDetailsDto
): details is HistoryDepositReferralRewardDto => {
  return "rewardLevel" in details && "amount" in details;
};

export const isDepositReward = (
  details: HistoryDetailsDto
): details is HistoryDepositRewardDto => {
  return "withdrawableTonAmount" in details;
};

export const isDepositRewardVesting = (
  details: HistoryDetailsDto
): details is HistoryDepositRewardVestingDto => {
  return "depositRewardId" in details;
};

export const isMatchingBonus = (
  details: HistoryDetailsDto
): details is HistoryDepositRewardRefBonusDto => {
  return "rankCode" in details;
};

export const isWithdrawalMatchingBonus = (
  details: HistoryDetailsDto
): details is HistoryWithdrawalDepositRewardRefBonusDto => {
  return (
    "bounce" in details &&
    "type" in details &&
    details.type === "dep-reward-ref-bonus"
  );
};

export const isWithdrawal = (
  details: HistoryDetailsDto
): details is HistoryWithdrawalDto => {
  return "toAddress" in details && !("fromAddress" in details);
};

export const isWTTBonus = (
  details: HistoryDetailsDto
): details is HistoryWTTBonusDto => {
  return "withdrawalId" in details && "userId" in details;
};

export const isDailyReward = (
  details: HistoryDetailsDto
): details is HistoryDepositRewardDailyDto => {
  return "tokenAmount" in details;
};

export const isWithdrawalRequest = (
  details: HistoryDetailsDto
): details is HistoryWithdrawalDto => {
  return (
    "toAddress" in details &&
    !("fromAddress" in details) &&
    "request" in details
  );
};

export const isReinvest = (
  details: HistoryDetailsDto
): details is HistoryWithdrawalReinvest => {
  return "status" in details && details.status === "Reinvest";
};
